module.exports = {
  methods: {
    hasPermission(permission) {
      //console.log(this.$store.getters.getPermissions);
      return this.$store.getters.getPermissions.indexOf(permission) == -1
        ? false
        : true;
    },
  },
};
